export default __webpack_public_path__ + "static/header-bg-8a52ef652a5f306755097238b48f12c8.jpg";